<span class="badge badge-pill text-uppercase"
  [ngClass]="getBackground()">
  @if (index) {
    <span>{{index}} - </span>
  }
  {{getSkogsvardTypText()}}
</span>